/*eslint-disable*/
import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import {makeStyles, withStyles} from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
// @material-ui/icons
import Camera from "@material-ui/icons/Camera";
import Palette from "@material-ui/icons/Palette";
import People from "@material-ui/icons/People";
import ScheduleIcon from '@material-ui/icons/Schedule';
import MenuBookIcon from '@material-ui/icons/MenuBook';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import SubscriptionsIcon from '@material-ui/icons/Subscriptions';
import Add from "@material-ui/icons/Add";
import Favorite from "@material-ui/icons/Favorite";
// core components
import Header from "components/Header/Header.js";
import Footer from "components/Footer/Footer.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
import NavPills from "components/NavPills/NavPills.js";
import Parallax from "components/Parallax/Parallax.js";
import Clearfix from "components/Clearfix/Clearfix.js";
import Button from "components/CustomButtons/Button.js";

import profilePageStyle from "assets/jss/material-kit-pro-react/views/profilePageStyle.js";
import BaseHeader from "./BaseView/BaseHeader";
import BaseFooter from "./BaseView/BaseFooter";
import AccountSchedule from "./account/AccountSchedule";
import AccountCourse from "./account/AccountCourse";
import AccountUserInfo from "./account/AccountUserInfo";
import storage from "../utils/storage";
import {getAccountSeries} from "../utils/request";
import LoadingCard from "./components/LoadingCard";

// const useStyles = makeStyles(profilePageStyle);
import intl from 'react-intl-universal';
import AccountSubscribe from "./account/AccountSubscribe";
// import dg1 from "*.jpg";
// import dg2 from "*.jpg";

import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Close from "@material-ui/icons/Close";

import Notifications from "@material-ui/icons/Notifications";
import Instruction from "../components/Instruction/Instruction";


function isEmpty(object) {
	if (object === null || object === undefined) {
		return true;
	}

	return false;
}


class Account extends React.Component {


	constructor(props, context) {
		super(props, context);
		this.state = {
			isPc: true,
			data: [],
		};
		this.state.isPc = storage.get("isPC");


		if (isEmpty(storage.get("token"))){
			this.props.history.push('/login');
		}

		this.initData();

		document.title = intl.get('account') + " - RobinAlgo";
	}

	initData = () => {
		getAccountSeries().then(res => {
			this.setState({
				data: res.data
			})
		})
	};

	render() {
		const {classes} = this.props;

		return (<div>
				<BaseHeader fixed/>
				<Parallax
					image={'https://robinalgo.oss-cn-shanghai.aliyuncs.com/account_bg.jpg'}
					filter="dark"
					className={classes.parallax}
				/>
				<div className={classNames(classes.main, classes.mainRaised)}
					 style={{backgroundColor: '#f9f9f9',}}
				>
					<div className={classes.container}>
						<GridContainer justify="center">
							<GridItem xs={12} sm={12} md={6}>
								<div className={classes.profile}>
									<div className={classes.name}>
										<h2 className={classes.title}
											style={{color: '#fff'}}>{this.state.data.userName}</h2>
									</div>
								</div>
							</GridItem>
						</GridContainer>
						<div className={classes.profileTabs}>

							{
								this.state.data.length === 0 ?
									<LoadingCard type={3}/>
									:
									<NavPills
										// alignCenter
										color="primary"
										active={1}
										horizontal=
											{
												this.state.isPc ?
													{
														tabsGrid: {xs: 12, sm: 3, md: 3},
														contentGrid: {xs: 12, sm: 9, md: 9}
													}
													:
													'notHorizontal'
											}
										tabs={[
											{
												tabButton: intl.get('my_profile'),
												tabIcon: AccountCircleIcon,
												tabContent: (
													<AccountUserInfo data={this.state.data}/>
												)
											},
											{
												tabButton: intl.get('my_subscribe'),
												tabIcon: SubscriptionsIcon,
												tabContent: (
													<AccountSubscribe data={this.state.data} enqueueSnackbar={this.props.enqueueSnackbar}/>
												)
											},
											{
												tabButton: intl.get('my_schedule'),
												tabIcon: ScheduleIcon,
												tabContent: (
													<AccountSchedule/>
												)
											},
											{
												tabButton: intl.get('my_series'),
												tabIcon: MenuBookIcon,
												tabContent: (
													<AccountCourse
														data={this.state.data.userSeries}/>
												)
											},
										]}
									/>
							}

						</div>
						<Clearfix/>
					</div>
				</div>
				<BaseFooter/>
			</div>
		);
	}
}

export default withStyles(profilePageStyle)(Account)
